import React, { useState, useEffect } from 'react';
import '../index.css';
import PersonalPropertiesModal from './PersonalPropertiesModal.js';

import Minibedicon from '../assets/mini-bed-icon.png'
import Bathicon from '../assets/bath-icon.png'
import Houseareaicon from '../assets/house-area-icon.png'
import Spinner from './Spinner.js';
import { useProperty } from '../context/PropertyContext.js';
import { useAuth } from '../context/AuthContext.js';
import { useNavigate } from 'react-router-dom';
import EditPersonalPropertiesModal from './EditPersonalPropertiesModal.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Pagination from './Pagination.js';
import { useNotification } from '../context/NotificationContext.js';


const serverUrlImage = 'https://osdevhub.com/projects/homify/uploads';

function formatWithComma(price) {
    return parseInt(price).toLocaleString('en-US');
}

const PersonalProperties = () => {
    const {fetchMyProperties, myProperties, deleteProperty,  propertyIsLoading, propertyErrorMessage, totalPages:allPages, fetchMyPropertiesPaginate} = useProperty();

    const {postNotification} = useNotification()

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(allPages || 1);
    const {user} = useAuth();
    const user_id = user.id;
    const limit = 9;

    async function handleDelete(id, name){
        deleteProperty(id).then(() => {
            fetchMyProperties(user_id); 
        });

        toast.success('Property deleted successfully', {
            position: "top-right",
            autoClose: 2000
        });

        
        const notifyData ={
          message: `You just deleted a property '${name}' `,
          type: 'personal',
          user_id: user.id,
          sender_id: user.id,
          url: `/dashboard/myproperties`
        }

        await postNotification(notifyData)
    }

    console.log(propertyIsLoading, propertyErrorMessage);
    


    const serverUrl = 'https://osdevhub.com/homify_backend';
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [editModalOpen, setEditModaOpen] = useState(false);
    const [property, setProperty] = useState({})


    const openEditModal = (selectedProperty) => {
        setProperty(selectedProperty);
        setEditModaOpen(true);
      }
      
    const closeEditModal = () => setEditModaOpen(false);

    const openModal = () => {
        setIsModalOpen(true)
    }
    const closeModal = () => setIsModalOpen(false);




    useEffect(() => {
        const fetchData = async () => {
            let data = {
                page: currentPage,
                limit: limit,
            };
            await fetchMyPropertiesPaginate(user_id, data);
        };
        
        fetchData();
    }, [user_id, currentPage, fetchMyPropertiesPaginate]);

        useEffect(() => {
            if(allPages){
                setTotalPages(allPages)
            }
        }, [allPages]);

        
        const handlePageChange =  async(page) => {
       
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page)
            let data = {
                page: page,
                limit: limit,
            }
            await fetchMyPropertiesPaginate(user_id, data);
        }
    }


    return (
        <div className='personal-properties-container margin-top'>
            <ToastContainer />
            <section id="seller-section" className="property-container margin-top2">
                <h2 className='margin-top'>My Properties</h2>
                <button onClick={openModal} className="upload-btn">Upload New Property</button>
                <PersonalPropertiesModal fetchMyProperties={fetchMyProperties} isOpen={isModalOpen} onClose={closeModal} />
                <EditPersonalPropertiesModal  property={property} isOpen={editModalOpen} onClose={closeEditModal} />
                <div className="recommendation-cardcontainer">
                {
                    propertyIsLoading ? (
                        <p style={{color:'#000'}}>Loading...</p>
                    ) : (
                        myProperties && myProperties.length !== 0 ? (
                            myProperties.map((property, index) => (
                                <MyPropertyCard 
                                    key={index}
                                    property={property} 
                                    openEditModal={openEditModal} 
                                    handleDelete={handleDelete} 
                                    fetchMyProperties={fetchMyProperties}
                                    editModalOpen={editModalOpen}
                                    closeEditModal={closeEditModal}
                                />
                            ))
                        ) : (
                            <p style={{color: '#000'}}>No properties found.</p>
                        )
                    )
                }
                </div>
            </section>
           
            <Pagination 
                currentPage={currentPage} 
                totalPages={totalPages} 
                onPageChange={handlePageChange} 
            />
        </div>
    );
};

function MyPropertyCard({property, handleDelete, openEditModal}){

    function newFeature() {
         toast.success('New Feature coming soon...', {
                  position: "top-right",
                  autoClose: 2000
              });
    }
    return    (
        <>
            <div className="recommendation-card">
        
                <img src={`${serverUrlImage}/${property.image}`} alt={property.name} />
                <div  className="recommendation-carddetails">
                    <h4>N{formatWithComma(property.price)}</h4>
                       <p><strong>Name:</strong> {property.name_of_property}</p>
                        <p><strong>Location:</strong> {property.address}</p>
                        <p><strong>Transaction:</strong> {property.transaction}</p>
                        <p><strong>Property Type:</strong> {property.type_of_property}</p>
                        <p><strong>Availability:</strong> Still available</p>
                </div>
                <div className="inner-carddetails">
                    <div className="innerdetails-content">
                        <div className="innerdetails-image">
                            <img src={Minibedicon} alt="" />
                            <p>{property.no_bedroom}</p>
                        </div>
                        <p>Bedroom</p>
                    </div>
                    <div className="innerdetails-content">
                        <div className="innerdetails-image">
                            <img src={Bathicon} alt="" />
                            <p>{property.no_bathroom}</p>
                        </div>
                        <p>Bathroom</p>
                    </div>
                    <div className="innerdetails-content">
                        <div className="innerdetails-image">
                            <img src={Houseareaicon} alt="" />
                            <p>{formatWithComma(property.house_area)}m</p>
                        </div>
                        <p>House Area</p>
                    </div>
                
                </div>
                <div>
                    <p className='description-text'><strong className='description-text'>Description:</strong> {property.description}</p>
                </div>
                <div>
                    <p className='description-text'><strong className='description-text'>Complete property verification:</strong> <span onClick={newFeature} className='upload-document'>Upload</span></p>
                </div>
                <div className="innerdetails-image">
                  <p>Status: {property.status === 'true' ? 'Approved' : 'Not Approved'}</p>
                </div>
            
                <div className="property-actions">
                    <button onClick={() => openEditModal(property)} className="edit-btn">Edit Property</button>
                    <button style={{marginLeft: '10px'}} className="edit-btn" onClick={() => handleDelete(property.id, property.name_of_property )}>Delete Property</button>
                </div>
            </div>
        </>

             
         
         )
 }


export default PersonalProperties;
